import type { ElementType, ReactNode } from "react";

/** Glasfläche (DESIGN-W82 „Tiefe und Licht“): `modul` Ecke 28, `flaeche` 26, `zeile` 24 (ruhig 22). Lebhaft mit Glanz
 *  und Lichtkante, ruhig mit Linie; Unschärfe nur mit `schwebend` (Tab-Leiste, Blasen, Hinweis; Kennzeichen
 *  data-schwebend), bei reduzierter Transparenz dichtes Glas ohne Unschärfe (welt.css). */
export function Glas(props: {
  art?: "modul" | "flaeche" | "zeile";
  schwebend?: boolean;
  als?: ElementType;
  className?: string;
  kennung?: string;
  /** Name für Vorlesen (`aria-label`), etwa an einem `aside` */
  name?: string;
  children?: ReactNode;
}) {
  const Element = props.als ?? "div";
  const art = props.art ?? "flaeche";
  return (
    <Element className={`glas glas-${art} ${props.className ?? ""}`} data-schwebend={props.schwebend ? "" : undefined} data-testid={props.kennung} aria-label={props.name}>
      {props.children}
    </Element>
  );
}
